module.exports = __webpack_public_path__ + "static/media/39.ae83e1d9.jpg";